import React from "react"
import propTypes from "prop-types"
import { Row, Col } from "reactstrap"

const TAX_LABELS = {
    IVA: "IVA",
    IEPS8: "IEPS 8%",
    IEPS23: "IEPS 23%",
}

const TAX_DISPLAY_ORDER = ["IEPS8", "IEPS23", "IVA"]

const BillingSummary = ({ subtotal, discount, taxBreakdown, total }) => {
    const taxLines = Object.entries(taxBreakdown || {})
        .filter(([, amount]) => Number(amount) > 0)
        .sort(([firstTaxKey], [secondTaxKey]) => {
            const firstIndex = TAX_DISPLAY_ORDER.indexOf(firstTaxKey)
            const secondIndex = TAX_DISPLAY_ORDER.indexOf(secondTaxKey)

            return (firstIndex === -1 ? TAX_DISPLAY_ORDER.length : firstIndex) -
                (secondIndex === -1 ? TAX_DISPLAY_ORDER.length : secondIndex)
        })

    return (
        // Resumen de la factura con subtotal, impuestos desglosados y total
        <Row className="mt-3">
            <Col md="8"></Col>
            <Col md="4">
                <div className="text-end">
                    <div>
                        <strong>
                            Subtotal: ${subtotal.toFixed(2)}
                        </strong>
                    </div>
                    {taxLines.map(([taxKey, amount]) => (
                        <div key={taxKey}>
                            <strong>
                                {TAX_LABELS[taxKey] || taxKey}: ${Number(amount).toFixed(2)}
                            </strong>
                        </div>
                    ))}
                    {Number(discount) > 0 && (
                        <div>
                            <strong>
                                Descuento: -${Number(discount).toFixed(2)}
                            </strong>
                        </div>
                    )}
                    <div>
                        <strong>
                            Total: ${total.toFixed(2)}
                        </strong>
                    </div>
                </div>
            </Col>
        </Row>
    )
}

BillingSummary.propTypes = {
    subtotal: propTypes.number.isRequired,
    discount: propTypes.number,
    taxBreakdown: propTypes.shape({
        IVA: propTypes.number,
        IEPS8: propTypes.number,
        IEPS23: propTypes.number,
    }).isRequired,
    total: propTypes.number.isRequired
}

BillingSummary.defaultProps = {
    discount: 0,
}

export default BillingSummary
